module.exports = __webpack_public_path__ + "static/logo-f67616c69b295471f07ebc268ab5d5a5.svg";